import {useNavigate} from '@github-ui/use-navigate'

import {CreateIssueButton} from './CreateIssueButton'

export type RepoScopedCreateIssueButtonProps = {
  owner: string
  repo: string
  label: string
  emojiSkinTonePreference?: number
}

export function RepoScopedCreateIssueButton({
  owner,
  repo,
  label,
  emojiSkinTonePreference,
}: RepoScopedCreateIssueButtonProps) {
  const navigate = useNavigate()

  return (
    <CreateIssueButton
      label={label}
      navigate={navigate}
      requiresRelayEnvironment={false}
      optionConfig={{
        issueCreateArguments: {repository: {owner, name: repo}},
        showRepositoryPicker: false,
        emojiSkinTonePreference,
        showFullScreenButton: true,
        canBypassTemplateSelection: true,
        navigate,
      }}
    />
  )
}
